// extracted by mini-css-extract-plugin
module.exports = {"app__header":"C_cg","app__footer":"C_bz","app__flex_row":"C_ch","app__content__list":"C_cj"};